import { useState, useEffect } from "react";
import { User } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UserAvatar({ userId, size = "md", className = "" }) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!userId) return;
    let revoke;
    const load = async () => {
      try {
        const res = await axios.get(`${API}/settings/profile-picture/${userId}`, {
          responseType: "blob",
        });
        const url = URL.createObjectURL(res.data);
        setBlobUrl(url);
        revoke = url;
      } catch (err) {
        // No avatar — fallback to initials
      }
    };
    load();
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [userId]);

  const sizes = {
    xs: "w-6 h-6 text-[8px]",
    sm: "w-8 h-8 text-[10px]",
    md: "w-10 h-10 text-xs",
    lg: "w-14 h-14 text-sm",
    xl: "w-20 h-20 text-lg",
    "2xl": "w-28 h-28 text-2xl",
  };

  const sizeClass = sizes[size] || sizes.md;

  if (blobUrl) {
    return (
      <img
        data-testid={`user-avatar-${size}`}
        src={blobUrl}
        alt="Profile"
        className={`${sizeClass} rounded-full object-cover ring-2 ring-emerald-200 ${className}`}
      />
    );
  }

  return (
    <div
      data-testid={`user-avatar-fallback-${size}`}
      className={`${sizeClass} rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center text-white font-bold ring-2 ring-emerald-200 ${className}`}
    >
      <User className="w-1/2 h-1/2" />
    </div>
  );
}
